import Styles from './LMSEditor.module.scss';
import { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
// component imports
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
import { useNavigate, Form, Message, ViewContext, AuthContext, useAPI, useCan } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { ViewImage } from 'components/form/file/file';
import CourseLogs from './CourseLogs';

// module imports
import { useParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import FeatherIcon from 'feather-icons-react';
import { Dialog, DialogTitle, Tooltip, MenuItem, Checkbox, Chip } from '@mui/material/';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import axios from 'axios';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';



export function LMSEditor(props) {

    const filter = createFilterOptions();
    const { courseId } = useParams();
    const { action: pageAction } = useParams();
    const navigate = useNavigate()
    const permission = useCan('lms.course.view')
    const { data: courseData, loading } = useAPI(pageAction === 'edit'
        ? `/api/lms/courses/?id=${courseId}` : '');
    const [courseDetails, setCourseDetails] = useState({
        id: "",
        title: "",
        subtitle: "",
        desc: "",
        goals: "",
        level: "N/A",
        icon: "",
        isCustomImage : 0
    })
    const [showAddModule, setShowAddModule] = useState({
        show: false,
        index: -1,
        action: "",
        moduleID: -1
    })

    const [modulesList, setModulesList] = useState([]);
    const [tags, setTags] = useState([]);
    const [courseTags, setCourseTags] = useState([]);
    const [uploadDone, setUploadDone] = useState();
    const [contentAccess, setContentAccess] = useState()
    const [existingCourses, setExistingCourses] = useState([])
    const [courseLogs, setCourseLogs] = useState([])
    const [showOptions, setShowOptions] = useState(false)
    // Back Button State 
    const [backToCourse, setBackToCourse] = useState(false);
   
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    useEffect(() => {
        if (pageAction !== 'edit' && pageAction !== 'create') {
            navigate('/notfound')
            return;
        }
        if (pageAction === 'edit') {
            if (!courseId) {
                navigate('/notfound')
            }
            if (courseData) {
                setCourseDetails(courseData[0]);
                setModulesList(courseData[0]?.modules)
                setContentAccess(courseData[0]?.courseContentAccess);
                setCourseTags(courseData[0]?.course_tags);
                setTags(courseData[0]?.tags_data);
                setUploadDone(false)
                document.title = props.t('LMS.LMSEditor.title.edit',
                    { courseName: courseData[0].title }
                )
                return;
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageAction, courseData])


    const handleInputChange = (name, value) => {
        setCourseDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const [confirmSubmit, setConfirmSubmit] = useState(false);

    const ModuleCard = ({ moduleData, index }) => {
        return (
            <>
                <div
                    id='moduleCard'
                    className={Styles.moduleCard}
                    style={{ marginBotton: moduleData?.sections?.length ? "0.5em" : "0" }}
                >
                    <div
                        id='infoContainer'
                        className={Styles.infoContainer}
                        onClick={() => { navigate(`/lms/course/${courseId}/module/${moduleData.id}/lectures`) }}
                    >
                        <p>{moduleData.name}</p>
                    </div>
                    <div id='actionsContainer' className={Styles.actionsContainer}>
                        <Tooltip title="Delete">
                            <span>
                                <FeatherIcon
                                    color='black'
                                    icon='trash'
                                    onClick={() => {
                                        alterModuleAction({
                                            action: "delete",
                                            editIndex: index,
                                            moduleID: moduleData.id
                                        })
                                    }}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <span>
                                <FeatherIcon
                                    color='black'
                                    icon='edit-2'
                                    onClick={() => {
                                        alterModuleAction({
                                            action: "edit",
                                            editIndex: index,
                                            moduleID: moduleData.id
                                        })
                                    }}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip title="View Lectures">
                            <span>
                                <FeatherIcon
                                    color='black'
                                    icon='chevron-right'
                                    onClick={() => { navigate(`/lms/course/${courseId}/module/${moduleData.id}/lectures`) }}
                                />
                            </span>
                        </Tooltip>
                    </div>
                </div>
            </>
        )
    }

    const alterModuleAction = ({ action, visibility = true, editIndex, moduleID, module_type }) => {

        if (action !== 'delete') {
            setShowAddModule(prevState => ({
                ...prevState,
                action: action,
                show: visibility,
                index: action === "edit" ? editIndex : -1,
                moduleID: action !== "add" ? moduleID : -1,
                module_type: module_type
            }));
            return;
        }
        if (action === 'delete') {
            setShowAddModule(prevState => ({
                ...prevState,
                action: action,
                show: false,
                index: editIndex,
                moduleID: moduleID
            }));
            setShowOptions(courseData?.[0]?.modules[editIndex]?.creator_id === authContext.user.creator_id || permission) 
            setConfirmSubmit(true)
        }
    }

    const modifyModules = async (moduleUpdateData, action, isAssociation = false) => {
        let endpoint
        if (isAssociation) {
            endpoint = `/api/lms/courses/${courseId}/modules/${moduleUpdateData.id}`;
        } else {
            endpoint = action === 'POST' ? `/api/lms/modules` : `/api/lms/modules/${moduleUpdateData.id}`;
        }

        const options = {
            method: action,
            url: endpoint,
            headers: {
                "accept": "application/json",
            },
            data: { ...moduleUpdateData, courseID: courseId },
        };
        axios
            .request(options)
            .then(function (response) {
                viewContext.notification.show(response.data.message, 'success');
                if (action === 'POST') {
                    const updatedModulesList = [
                        ...modulesList,
                        {
                            ...moduleUpdateData.newestModule,
                            id: response.data.moduleData.id
                        }
                    ];
                    setModulesList(updatedModulesList);
                }

            })
            .catch((err) => {
                let status = err.response.status;
                if (status === "401") {
                    authContext.signout()
                }
                viewContext.notification.show(err.response.data.message, 'error');
            });
    }

    const handleModuleDelete = async () => {
        await modifyModules({ id: showAddModule.moduleID, orderID: showAddModule.index }, 'DELETE')
        const updatedModulesList = modulesList.filter((_, index) => index !== showAddModule.index);
        setModulesList(updatedModulesList);
        discardCloseModule()
    }

    const discardCloseModule = () => {
        setShowAddModule({
            show: false,
            index: -1,
            action: "",
            moduleID: -1
        })
    }

    const AddModuleJSX = () => {
        const [newModule, setNewModule] = useState({
            name: showAddModule.action === "edit" ? modulesList[showAddModule.index].name : "",
            id: showAddModule.action === "edit" ? modulesList[showAddModule.index].id : "",
        })

        const handleChange = (e) => {
            const { name, value } = e.target;
            setNewModule(prevState => ({
                ...prevState,
                [name]: value,
            }));
        };

        const existingModulesSelect = (e, values) => {
            setNewModule({
                name: values?.title,
                id: values?.module_id
            });
        }

        const confirmUpdate = () => {
            if (showAddModule.action === "edit") {
                const updatedModulesList = [...modulesList];
                updatedModulesList[showAddModule.index] = newModule;
                modifyModules({ id: newModule.id, title: newModule.name, orderID: showAddModule.index }, 'PATCH')
                setModulesList(updatedModulesList);
            } else {
                modifyModules({
                    title: newModule.name,
                    moduleID: newModule.id || null,
                    orderID: modulesList.length + 1,
                    newestModule: newModule,
                }, 'POST')
            }
            discardCloseModule()
        }

        const getExistingModules = () => {
            axios.get(`/api/lms/courses/modules/existing?course_id=${courseId}`)
                .then((res) => {
                    setExistingCourses(res.data.data)
                    alterModuleAction({ action: "add", module_type: 'existing_module' })
                })
                .catch((err) => {
                    console.log(err)
                })
        }

        return (
            <Dialog
                onClose={discardCloseModule}
                open={showAddModule.show}
            >
                <DialogTitle>
                    {showAddModule.action.toUpperCase()} MODULE
                </DialogTitle>
                {
                    (showAddModule.action === 'add' && !showAddModule?.module_type) &&
                    <div
                        id='addModuleContainer'
                        style={{ display: 'flex', flexDirection: 'row', margin: '0.5em' }}
                        className={Styles.addModuleContainer}
                    >
                        <AivagamButton
                            buttonText={'Add New Module'}
                            onClick={() => { alterModuleAction({ action: "add", module_type: 'new_module' }) }}
                        />
                        <AivagamButton
                            buttonText={'Add Existing Module'}
                            onClick={() => { getExistingModules(); }}
                        />
                    </div>
                }


                <div id='addModuleContainer' className={Styles.addModuleContainer}>
                    {(showAddModule?.module_type === 'new_module' || showAddModule.action === 'edit') &&
                        <span>
                            <p className={`${Styles.pageTitle} ${Styles.inputHeading}`}>
                                Module Name
                            </p>
                            <TextField
                                id={`module-name`}
                                name="name"
                                fullWidth
                                placeholder="Name the Module a Suitable Title"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    maxLength: 100
                                }}
                                value={newModule.name || ""}
                                onChange={handleChange}
                            />
                        </span>
                    }
                    {showAddModule?.module_type === 'existing_module' &&
                        <div id='addModuleContainer' style={{ width: '100%' }} className={Styles.addModuleContainer}>
                            <p className={`${Styles.pageTitle} ${Styles.inputHeading}`}>
                                Module Name
                            </p>
                            {<Autocomplete
                                // value={newModule.name || ''}
                                id="module_select"
                                options={existingCourses?.length ? existingCourses : []}
                                onChange={existingModulesSelect}
                                getOptionSelected={(option, value) => (option.title === value.title)}
                                getOptionLabel={(option) => (option ? option?.title : '')}
                                renderInput={(params) => <TextField {...params} label="Select Module" />}

                            />}
                        </div>
                    }
                    {(showAddModule?.module_type || showAddModule.action === 'edit') && <div id='addModBtnContainer' className={Styles.addModBtnContainer}>
                        <AivagamButton
                            buttonText={"Cancel"}
                            onClick={discardCloseModule}
                            icon
                            type="cancel"
                        />
                        <AivagamButton
                            buttonText={
                                showAddModule.action === "edit" ?
                                    "Update Module"
                                    : "Add Module"
                            }
                            disabled={!newModule?.name?.length || newModule?.name === courseData[0]?.modules[showAddModule.index]?.name}
                            onClick={confirmUpdate}
                            icon
                            type="confirm"
                        />
                    </div>}
                </div>
            </Dialog>
        )
    }

    const courseTypes = [
        {
            "value": "beginner",
            "label": "Beginner"
        },
        {
            "value": "intermediate",
            "label": "Intermediate"
        },
        {
            "value": "advanced",
            "label": "Advanced"
        }
    ]

    const authContext = useContext(AuthContext)
    const viewContext = useContext(ViewContext)

    function findDifferences(courseDetails, courseData) {
        return _.omitBy(courseDetails, (value, key) => _.isEqual(value, courseData[key]));
    }

    const updateData = (action) => {

        const endpoint = action === "POST" ? "/api/lms/courses" : `/api/lms/courses/${courseId}`
        //TODO: Compare between courseDetails and courseData and only send key:values which are different
        let dataToUpdate = courseDetails
        if (courseData) {
            dataToUpdate = findDifferences(courseDetails, courseData[0])
        }
        const options = {
            method: action,
            url: endpoint,
            headers: {
                "accept": "application/json",
            },
            data: dataToUpdate,
        };
        axios
            .request(options)
            .then(function (response) {
                if (pageAction === 'create') {
                    navigate(`/lms/course/${courseDetails.id}/edit`)
                    window.location.reload()
                }
                viewContext.notification.show(response.data.message, 'success');
                setTimeout(() => {
                    window.location.reload()
                }, 500);
            })
            .catch((err) => {
                let status = err.response.status;
                let message = "Failed to update course status."
                if (status === 401) {
                    authContext.signout()
                }
                if (status === 409) {
                    message = `${err.response.data.message}`
                }
                viewContext.notification.show(`${message}`, 'error');
            });
    }

    const updateCourseStatus = (status) => {
        const updatedCourseDetails = { ...courseDetails };
        updatedCourseDetails.status = status;
        const options = {
            method: "PATCH",
            url: `/api/lms/courses/${courseId}/status`,
            headers: {
                "accept": "application/json",
            },
            data: updatedCourseDetails,
        };
        axios
            .request(options)
            .then(function (response) {
                handleInputChange('status', status)
                Event(`course_${status}`, { courseID: courseDetails?.id });
                viewContext.notification.show(response.data.message, 'success');
            })
            .catch((err) => {
                let status = err.response.status;
                let message = "Failed to update course status."
                if (status === 401) {
                    authContext.signout()
                }
                if (status === 409) {
                    message = `${err.response.data.message}`
                }
                viewContext.notification.show(`${message}`, 'error');
            });
    }

    const Event = require('components/lib').Event;

    const onContentAccessChange = (event, newValue) => {
        setContentAccess(newValue);
    };

    const handleContentAccessUpdate = () => {
        const options = {
            method: "PATCH",
            url: `/api/lms/courses/${courseId}/access`,
            headers: {
                "accept": "application/json",
            },
            data: { contentAccess: contentAccess },
        };
        axios
            .request(options)
            .then(function (response) {
                if (response.status === 200) {
                    viewContext.notification.show("Successfully updated Content Access", 'success')
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show("Failed to update content access.", 'error');
            });
    }

    const getOptionDisabled = (option) => {
        if (courseTags?.length >= 5) {
            return !courseTags.find(val => val?.label === option?.label);
        }
        return false;
    };

    const handleCourseTagsUpdate = () => {
        const options = {
            method: "PATCH",
            url: `/api/lms/courses/${courseId}/tags`,
            headers: {
                "accept": "application/json",
            },
            data: { courseTags: courseTags },
        };
        axios
            .request(options)
            .then(function (response) {
                if (response.status === 201) {
                    setCourseTags(response.data.data);
                    viewContext.notification.show("Successfully updated Course Tags", 'success');
                }
            })
            .catch((err) => {
                let status = err.response.status;
                let message = "Failed to update content tags."
                if (status === 401) {
                    authContext.signout()
                }
                else if (status === 409) {
                    message = `${err.response.data.message}`
                }
                viewContext.notification.show(`${message}`, 'error');
            });
    }

    const setDefaultCourseImage = () => {
        const options = {
            method: pageAction === "create" ? "POST" : "PATCH",
            url: pageAction === "create" ? `/api/lms/course/content/default` : `/api/lms/course/${courseId}/content/default`,
            headers: {
                "accept": "application/json",
            }
        };
        axios
            .request(options)
            .then(function (response) {
                handleInputChange("icon", response.data.contentUrl)
                if (pageAction === "create") {
                    handleInputChange("id", response.data.id)
                    handleInputChange("isCustomImage", 0)
                }
                Event(`default_course_image_${pageAction}ed`);
                viewContext.notification.show("Default image set!.", 'success');
                if (pageAction !== "create") {
                    setTimeout(() => {
                        window.location.reload()
                    }, 500);
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show("Failed to update course image.", 'error');
            });
    }

    const handleViewLogs = () => {
        const options = {
            method: "GET",
            url: `/api/lms/courses/${courseId}/logs`,
            headers: {
                "accept": "application/json",
            }
        };
        axios
            .request(options)
            .then(function (response) {
                if (response.data?.data?.length) {
                    setCourseLogs(response?.data?.data)
                } else {
                    viewContext.notification.show("Failed to fetch logs.", 'error');
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show("Failed to fetch logs.", 'error');
            });
    }

    const handleDeleteAssociation = async () => {
        await modifyModules({ id: showAddModule.moduleID, orderID: showAddModule.index }, 'DELETE', true)
        const updatedModulesList = modulesList.filter((_, index) => index !== showAddModule.index);
        setModulesList(updatedModulesList);
        discardCloseModule()
    }

    const onBackButton = () => {

        if (pageAction === 'create') {
            setBackToCourse(true)
        }

        else if (pageAction === 'edit') {
            const CheckUpdatedData = findDifferences(courseDetails, courseData[0])
            if (Object.keys(CheckUpdatedData).length !== 0 && CheckUpdatedData.constructor === Object) {
                setBackToCourse(true)

            } else {

                navigate('/lms/courses/all')
            }

        }
        else {

            navigate('/lms/courses/all')
        }

    }

    return (       
        <div id='ancestorContainer' className={Styles.ancestorContainer}>
            {loading && <LoadingBackdrop isOpen={loading} />}
            <ConfirmationCard
                title={'Delete Module?'}
                body={showOptions ? "Where would you like to delete this module from?" : "Deleting this module will remove it from the course. Are you sure you want to continue?"}
                showCard={confirmSubmit}
                setShowCard={setConfirmSubmit}
                handleConfirm={handleModuleDelete}
                destructive={true}
                moduleCard={true}
                showOptions={showOptions}
                handleDeleteAssociation={handleDeleteAssociation}
            />
              {/* back to Course Card */}
              
            <ConfirmationCard
                title={"Go Back"}
                body={"Are you sure you want to navigate away from this page? Your Changes will not be saved if you go back."}
                showCard={backToCourse}
                setShowCard={setBackToCourse}

                handleConfirm={() => { navigate('/lms/courses/all') }}
            />



             <button onClick={() => { onBackButton() }} className={Styles.courseReview }>
                    <FeatherIcon size="0.9em" icon="arrow-left" /> Back
                </button>
                {/* back to Course Card */} 
            <span className={Styles.titleContainer}>
                <p className={Styles.pageTitle}>
                    {pageAction.toUpperCase()} COURSE:
                </p>
                {pageAction === 'edit' &&
                    <span
                        className={Styles.courseActionButtons}
                    >
                        <AivagamButton
                            buttonText={
                                <>
                                    <FeatherIcon
                                        color='black'
                                        icon='file-text'
                                    />
                                    View Logs
                                </>
                            }
                            type="action"
                            onClick={handleViewLogs}
                            icon
                        />
                        <AivagamButton
                            buttonText={
                                <>
                                    <FeatherIcon
                                        color='white'
                                        icon='eye-off'
                                    />
                                    Archive
                                </>
                            }
                            onClick={() => {
                                updateCourseStatus('archived')
                            }}
                            icon
                            disabled={courseDetails?.status !== 'published'}
                        />
                        <AivagamButton
                            buttonText={
                                <>
                                    <FeatherIcon
                                        color='white'
                                        icon='upload'
                                    />
                                    Publish
                                </>
                            }
                            onClick={() => {
                                updateCourseStatus('published')
                            }}
                            icon
                            type="confirm"
                            disabled={courseDetails?.status === 'published' || modulesList.length === 0}
                        />
                    </span>
                }
            </span>
            <p className={Styles.warnText}>
                {modulesList.length === 0 ? "Add modules with lectures to Publish this course." : " "}
            </p>
            {(pageAction === 'create' ? 'true' : !loading) &&
                <div id='basicInfo' className={Styles.basicInfo}>
                    <p>
                        Course Title *
                    </p>
                    <TextField
                        id={`course-name`}
                        name="title"
                        // label="Course Title"
                        placeholder="Eg: Data Security"
                        // helperText={'Enter the Course Description'}
                        InputProps={{
                            maxLength: 100
                        }}
                        value={courseDetails?.title || ""}
                        onChange={(e) => { handleInputChange(e.target.name, e.target.value) }}
                    />
                    <p>
                        Course Subtitle *
                    </p>
                    <TextField
                        id={`course-subtitle`}
                        name="subtitle"
                        // label="Course Title"
                        placeholder="Eg: Data Security is an integral part of any tech stack and organisation!"
                        // helperText={'Enter the Course Subtitle'}
                        InputProps={{
                            maxLength: 250
                        }}
                        value={courseDetails?.subtitle || ""}
                        onChange={(e) => { handleInputChange(e.target.name, e.target.value) }}
                    />
                    <p>
                        Course Description *
                    </p>
                    <TextField
                        id={`course-description`}
                        name="desc"
                        // label="Course Description"
                        multiline={true}
                        placeholder={`Describe the aim of this course in a few lines.`}
                        // helperText={'Enter the Name of the Course Here'}
                        rows={5}

                        value={courseDetails?.desc || ""}
                        onChange={(e) => { handleInputChange(e.target.name, e.target.value) }}
                    />
                    <p>
                        Course Goals *
                    </p>
                    <TextField
                        id={`course-goals`}
                        name="goals"
                        // label="Course Goals"
                        multiline={true}
                        placeholder="Provide an explanation in a few lines what the purpose of this course is. Separate points by a full stop to generate bullet points."
                        helperText={'Separate points by a full stop to generate bullet points.'}
                        rows={5}

                        value={courseDetails?.goals || ""}
                        onChange={(e) => { handleInputChange(e.target.name, e.target.value) }}
                    />
                    <p>
                        Course Level
                    </p>
                    <TextField
                        id={`course-level`}
                        name="level"
                        select
                        fullWidth
                        value={courseDetails?.level || "N/A"}
                        onChange={(e) => { handleInputChange(e.target.name, e.target.value) }}
                        SelectProps={{
                            defaultValue: "N/A"
                        }}
                    >
                        <MenuItem key={"blankValue"} value={"N/A"}>
                            N/A
                        </MenuItem>
                        {courseTypes?.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <p>
                        Course Image *
                    </p>
                    <span>
                        {!uploadDone ? (
                            (pageAction === 'edit' ? courseDetails?.icon : true) && (
                                <Form
                                    buttonText={pageAction === 'create' ? 'Upload Course Image' : 'Update Course Image'}
                                    url={courseDetails?.icon ? `/api/lms/course/${courseId}/content/` : "/api/lms/course/image"}
                                    method={courseDetails?.icon ? 'PATCH' : 'POST'}
                                    inputs={{
                                        course_img: {
                                            label: "Max File Size: 600KB",
                                            type: 'file',
                                            max: 1,
                                            onlyImage: true,
                                            maxFileSize: 600,
                                            accept: ['png', 'webp', 'jpg', 'jpeg'],
                                            imageFullUrl: `${process.env.REACT_APP_AZURE_STORAGE_MEDIA_URL}${courseDetails?.icon}`
                                        }
                                    }}
                                    callback={(res) => {
                                        setUploadDone(true);
                                        handleInputChange("icon", res.data.contentUrl)
                                        if (pageAction === "create") { 
                                            handleInputChange("id", res.data.id);
                                            handleInputChange("isCustomImage", res.data.isCustomImage);
                                        }
                                        Event('course_image_uploaded');
                                    }}
                                />
                            )
                        ) : (
                            <Message
                                title='Course Image Saved'
                                type='success'
                                text={
                                    pageAction === 'create' ?
                                        'The course image has been saved successfully. Please fill the Course Details and Save a Draft Copy to Continue.' :
                                        'The course image has been updated. The updated image will be reflected in a few minutes!'
                                }
                            />
                        )}
                        <div className={Styles.verticalBreak}>
                            <hr></hr>
                            OR
                            <hr></hr>
                        </div>
                        <div
                            className={Styles.ownImageDiv}
                            style={{
                                opacity: courseDetails?.[0]?.icon?.startsWith(`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/website/course.png`) ? 0.5 : 1,
                                pointerEvents: courseDetails?.[0]?.icon?.startsWith(`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/website/course.png`) ? "none" : "",
                            }}
                        >
                            <div>
                                <ViewImage
                                    imageFullUrl={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/website/course.png`}
                                    onlyImage={true}
                                />
                            </div>
                            <AivagamButton
                                buttonText={
                                    courseDetails?.[0]?.icon?.startsWith(`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/website/course.png`)
                                        ? "Default Image Set"
                                        : "Set Default Course Image"
                                }
                                onClick={() => {
                                    setDefaultCourseImage()
                                }}
                                disabled={courseDetails?.[0]?.icon?.startsWith(`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/website/course.png`)}
                                icon
                                type="confirm"
                                classStyles={{ width: "100%", marginTop: "1em", boxShadow: "none" }}
                            />
                        </div>
                    </span>
                    <span>
                        <AivagamButton
                            buttonText={
                                <>
                                    <FeatherIcon
                                        color='white'
                                        icon='save'
                                    />
                                    {pageAction === 'create' ? "Save Draft" : "Update"}
                                </>
                            }
                            onClick={() => {
                                if (pageAction === "create") {
                                    updateData("POST")
                                    Event('course_drafted', { courseID: courseDetails?.id });
                                } else {
                                    updateData("PATCH")
                                    Event('course_patched', { courseID: courseDetails?.id });
                                }
                            }}
                            icon
                            // type="action"
                            disabled={Object.values(courseDetails)?.some(value => value === "")}
                        />
                    </span>
                </div>
            }
            {(pageAction === 'edit' && !loading) &&
                <>
                    <div id='contentAccessContainer' className={Styles.editorContainer}>
                        <p className={`${Styles.pageTitle} ${Styles.inputHeading}`}>
                            Content Access Level
                        </p>
                        <p className={Styles.explainStyles}>
                            Select the Departments and Business Units for which this course should be restricted to.
                            Manage your Organisation Hierarchy <a href='/account/hierarchy'>Here</a>
                        </p>
                        <div id='contentAccessInputs' className={Styles.contentAccessInputs}>
                            <Autocomplete
                                id="grouped-demo"
                                sx={{ width: "80%" }}
                                options={courseDetails?.contentAccess?.length ? courseDetails?.contentAccess : []}
                                limitTags={4}
                                onChange={onContentAccessChange}
                                value={contentAccess || []}
                                groupBy={(option) => option.businessUnit}
                                isOptionEqualToValue={(option, value) =>
                                    (option.value === value.value) && (option.bu_id === value.bu_id)
                                }
                                getOptionLabel={(option) => (option.value === "all" ? `All ${option.businessUnit} Departments` : option.label)}
                                multiple

                                disableCloseOnSelect
                                renderInput={(params) => <TextField {...params} label="Select Content Access" helperText={courseDetails?.contentAccess?.length ? " " : "Create Departments under Business Units to assign access level"} />}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => {
                                        if (contentAccess.some((selectedOption) => (selectedOption.value === "all"
                                            && selectedOption.businessUnit === option.businessUnit
                                            && option.value !== "all"))) {
                                            return null
                                        } else {
                                            return (
                                                <Chip
                                                    key={index}
                                                    label={`${option.businessUnit}: ${option.label}`}
                                                    {...getTagProps({ index })}
                                                />
                                            )
                                        }
                                    })
                                }
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.value === "all" ? `All ${option.businessUnit} Departments` : option.label}
                                    </li>
                                )}
                            />
                            <AivagamButton
                                buttonText={
                                    <>
                                        <FeatherIcon
                                            color='black'
                                            icon='shield'
                                        />
                                        Update Access
                                    </>
                                }
                                type="action"
                                onClick={handleContentAccessUpdate}
                                icon
                                disabled={courseDetails?.contentAccess?.length === 0}
                            />
                        </div>
                    </div>

                    <div id='courseTagsContainer' className={Styles.editorContainer}>
                        <p className={`${Styles.pageTitle} ${Styles.inputHeading}`}>
                            Add Course Tags
                        </p>
                        <div id='contentAccessInputs' className={Styles.contentAccessInputs}>
                            <Autocomplete
                                multiple
                                value={courseTags || []}
                                sx={{ width: "80%" }}
                                limitTags={4}
                                getOptionDisabled={getOptionDisabled}
                                onChange={(event, newValue) => {
                                    if (typeof newValue === 'string') {
                                        setCourseTags([...courseTags, { label: newValue }]);
                                    } else if (Array.isArray(newValue)) {
                                        setCourseTags(newValue.map(value =>
                                            typeof value === 'string' ? { label: value, newValue: value } : value
                                        ));
                                    }
                                }}
                                filterOptions={(options, params) => {
                                    const filtered = filter(options, params);
                                    const { inputValue } = params;

                                    // Suggest the creation of a new value
                                    const isExisting = options.some((option) => inputValue === option.label);
                                    if (inputValue !== '' && !isExisting) {
                                        filtered.push({
                                            newValue: inputValue,
                                            label: `New "${inputValue}"`,
                                        });
                                    }

                                    return filtered;
                                }}
                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                                id="free-solo-with-text-demo"
                                options={tags || []}
                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') {
                                        return option;
                                    }
                                    if (option.newValue) {
                                        return option.newValue;
                                    }
                                    return option.label;
                                }}
                                isOptionEqualToValue={(option, value) =>
                                    option.label === value.label
                                }
                                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                                freeSolo
                                renderInput={(params) => (
                                    <TextField {...params} label="Course Tags" />
                                )}
                            />
                            <AivagamButton
                                buttonText={
                                    <>
                                        <FeatherIcon
                                            color='black'
                                            icon='tag'
                                        />
                                        Add Tags
                                    </>
                                }
                                type="action"
                                onClick={handleCourseTagsUpdate}
                                icon
                                disabled={courseTags?.length === 0}
                            />
                        </div>
                    </div>

                    <div id='editorContainer' className={Styles.editorContainer}>
                        <div id='editorButtons' className={Styles.editorButtons}>
                            <p className={`${Styles.pageTitle} ${Styles.inputHeading}`}>
                                Modules: {modulesList?.length}
                            </p>
                            <AivagamButton
                                buttonText={
                                    <>
                                        <FeatherIcon
                                            color='black'
                                            icon='plus'
                                        />
                                        Add Module
                                    </>
                                }
                                onClick={() => { alterModuleAction({ action: "add" }) }}
                                icon
                                type="edit"
                            />
                        </div>
                        {(modulesList?.length !== 0) &&
                            <div id='contentContainer' className={Styles.contentContainer}>
                                {modulesList.map((module, index) => (
                                    <ModuleCard
                                        key={`${index}-module`}
                                        moduleData={module}
                                        index={index}
                                    />
                                ))}
                            </div>
                        }
                        {showAddModule?.show && <AddModuleJSX />}
                    </div>
                </>
            }
            {(pageAction === 'edit' && !loading) &&
                <>
                    <CourseLogs setCourseLogs={setCourseLogs} courseLogs={courseLogs} />
                </>
            }
        </div >
    )
}
